class SocialShare extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  
  init() {
    const shareBtns = this.querySelectorAll('.btn-sharing');
    if (!shareBtns.length) return;

    shareBtns.forEach((share) => {
      share.addEventListener('click', (event) => {
        event.preventDefault();
        const target = event.currentTarget;
        const social = target?.getAttribute('data-social');
        if (social) {
          window.open(social, '_blank', 'noopener,noreferrer');
        }
      }, false);
    });
  }
}

if (!customElements.get('social-share')) {
  customElements.define('social-share', SocialShare);
}